import { API_CALL } from '../../middleware/api';

export const LIST_SURVEYS = 'LIST_SURVEYS';
export const LIST_SURVEYS_RESULT = `${LIST_SURVEYS}/result`;
export const CREATE_SURVEY = 'CREATE_SURVEY';
export const CREATE_SURVEY_RESULT = `${CREATE_SURVEY}/result`;
export const GET_SURVEY = 'GET_SURVEY';
export const GET_SURVEY_RESULT = `${GET_SURVEY}/result`;
export const UPDATE_SURVEY = 'UPDATE_SURVEY';
export const UPDATE_SURVEY_RESULT = `${UPDATE_SURVEY}/result`;
export const PUBLISH_SURVEY = 'PUBLISH_SURVEY';
export const PUBLISH_SURVEY_RESULT = `${PUBLISH_SURVEY}/result`;
export const ARCHIVE_SURVEY = 'ARCHIVE_SURVEY';
export const ARCHIVE_SURVEY_RESULT = `${ARCHIVE_SURVEY}/result`;
export const PREVIEW_SURVEY = 'PREVIEW_SURVEY';
export const PREVIEW_SURVEY_RESULT = `${PREVIEW_SURVEY}/result`;
export const SEND_SURVEY = 'SEND_SURVEY';
export const SEND_SURVEY_RESULT = `${SEND_SURVEY}/result`;
export const LIST_SURVEY_ASSIGNMENTS = 'LIST_SURVEY_ASSIGNMENTS';
export const LIST_SURVEY_ASSIGNMENTS_RESULT = `${LIST_SURVEY_ASSIGNMENTS}/result`;
export const GET_SURVEY_ASSIGNMENT = 'GET_SURVEY_ASSIGNMENT';
export const GET_SURVEY_ASSIGNMENT_RESULT = `${GET_SURVEY_ASSIGNMENT}/result`;
export const REVOKE_SURVEY_ASSIGNMENT = 'REVOKE_SURVEY_ASSIGNMENT';
export const REVOKE_SURVEY_ASSIGNMENT_RESULT = `${REVOKE_SURVEY_ASSIGNMENT}/result`;
export const GET_SURVEY_REPORT = 'GET_SURVEY_REPORT';
export const GET_SURVEY_REPORT_RESULT = `${GET_SURVEY_REPORT}/result`;
export const EXPORT_SURVEY = 'EXPORT_SURVEY';
export const EXPORT_SURVEY_RESULT = `${EXPORT_SURVEY}/result`;
export const SURVEY_RECIPIENT_PATIENTS = 'SURVEY_RECIPIENT_PATIENTS';
export const SURVEY_RECIPIENT_PATIENTS_RESULT = `${SURVEY_RECIPIENT_PATIENTS}/result`;
export const SURVEY_CONDITIONS = 'SURVEY_CONDITIONS';
export const SURVEY_CONDITIONS_RESULT = `${SURVEY_CONDITIONS}/result`;
export const SURVEY_FACILITIES = 'SURVEY_FACILITIES';
export const SURVEY_FACILITIES_RESULT = `${SURVEY_FACILITIES}/result`;
export const LIST_PATIENT_SURVEYS = 'LIST_PATIENT_SURVEYS';
export const LIST_PATIENT_SURVEYS_RESULT = `${LIST_PATIENT_SURVEYS}/result`;
export const SURVEY_ACCESS = 'SURVEY_ACCESS';
export const SURVEY_ACCESS_RESULT = `${SURVEY_ACCESS}/result`;

const surveyUrl = id => `portal/surveys/${id}`;

export const actions = {
  listSurveys: () => ({
    [API_CALL]: { method: 'GET', endpoint: 'portal/surveys/', latest: LIST_SURVEYS },
    type: LIST_SURVEYS,
  }),
  createSurvey: title => ({
    [API_CALL]: { method: 'POST', endpoint: 'portal/surveys/', data: { title } },
    type: CREATE_SURVEY,
  }),
  getSurvey: id => ({
    [API_CALL]: { method: 'GET', endpoint: `${surveyUrl(id)}/` },
    type: GET_SURVEY,
  }),
  updateSurvey: (id, revision, draft) => ({
    [API_CALL]: { method: 'PUT', endpoint: `${surveyUrl(id)}/`, data: { revision, draft } },
    type: UPDATE_SURVEY,
  }),
  publishSurvey: (id, revision) => ({
    [API_CALL]: { method: 'POST', endpoint: `${surveyUrl(id)}/publish`, data: { revision } },
    type: PUBLISH_SURVEY,
  }),
  archiveSurvey: id => ({
    [API_CALL]: { method: 'DELETE', endpoint: `${surveyUrl(id)}/` },
    type: ARCHIVE_SURVEY,
  }),
  // The builder preview: only the newest draft's preview may replace the rendered survey.
  previewSurvey: definition => ({
    [API_CALL]: { method: 'POST', endpoint: 'portal/surveys/preview', data: { definition }, latest: PREVIEW_SURVEY },
    type: PREVIEW_SURVEY,
  }),
  sendSurvey: (id, data) => ({
    [API_CALL]: { method: 'POST', endpoint: `${surveyUrl(id)}/send`, data },
    type: SEND_SURVEY,
  }),
  listAssignments: id => ({
    [API_CALL]: { method: 'GET', endpoint: `${surveyUrl(id)}/assignments`, latest: LIST_SURVEY_ASSIGNMENTS },
    type: LIST_SURVEY_ASSIGNMENTS,
  }),
  getAssignment: (id, assignmentId) => ({
    [API_CALL]: { method: 'GET', endpoint: `${surveyUrl(id)}/assignments/${assignmentId}` },
    type: GET_SURVEY_ASSIGNMENT,
  }),
  revokeAssignment: (id, assignmentId) => ({
    [API_CALL]: { method: 'POST', endpoint: `${surveyUrl(id)}/assignments/${assignmentId}/revoke` },
    type: REVOKE_SURVEY_ASSIGNMENT,
  }),
  getReport: id => ({
    [API_CALL]: { method: 'GET', endpoint: `${surveyUrl(id)}/report`, latest: GET_SURVEY_REPORT },
    type: GET_SURVEY_REPORT,
  }),
  // kind: 'export' (responses) or 'codebook'
  exportSurvey: (id, kind) => ({
    [API_CALL]: { method: 'GET', endpoint: `${surveyUrl(id)}/${kind}` },
    type: EXPORT_SURVEY,
  }),
  // Every survey sent to one patient, with answers lined up for comparison.
  listPatientSurveys: patientUuid => ({
    [API_CALL]: { method: 'GET', endpoint: `portal/surveys/patients/${patientUuid}`, latest: LIST_PATIENT_SURVEYS },
    type: LIST_PATIENT_SURVEYS,
  }),
  searchPatients: search => ({
    [API_CALL]: { method: 'GET', endpoint: 'portal/patients/list', params: { search, offset: 0, limit: 50 } },
    type: SURVEY_RECIPIENT_PATIENTS,
  }),
  getConditions: () => ({
    [API_CALL]: { method: 'GET', endpoint: 'portal/patients/cohorts/conditions/summary', params: { limit: 1000000 } },
    type: SURVEY_CONDITIONS,
  }),
  getFacilities: () => ({
    [API_CALL]: { method: 'GET', endpoint: 'portal/patients/cohorts/facilities/summary', params: { limit: 1000000 } },
    type: SURVEY_FACILITIES,
  }),
  // Patient side of a survey link; action is load, save or submit.
  surveyAccess: (action, data) => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/survey-access/${action}`, data },
    type: SURVEY_ACCESS,
  }),
};

export const errorMessage = (response, fallback) =>
  response?.response?.data?.error?.message || response?.response?.data?.standard_error?.message || fallback;
